<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules">
        <!-- <div class="tit_label">车辆添加</div> -->
        <div class="bainfo">
          <FormItem v-for="(c, i) in formCtrl" :key="'formItem' + i" :viewMode="viewMode" :config="c"
            :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" :class="c.className" />
        </div>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import mixin from "./mixin";

export default {
  mixins: [detailMixin, mixin],
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/manage` },
        { name: "车辆列表", path: `/vehicle/manage` },
        { name: "车辆添加" },
      ],
      labelWidth: "180px",
      form: {
        fleet: undefined,
        carstatus: undefined,
        license: undefined,
        driver: undefined,
        escort: undefined,
        trailer_id: undefined,
        ton: undefined,
        vtype: undefined,
        buytime: undefined,
        asset: undefined,
        amortization: undefined,
        prepaid_type_id:undefined
      },
      rules: {
        // license: [
        //   { required: true, validator: this.checkLicense, trigger: "blur" },
        // ],
        license: [
          { required: true, message: "请填写车牌号", trigger: "blur" },
        ],
        ton: [
          { required: true, message: "请填写载货重量", trigger: "blur" },
        ],
        buytime: [
          { required: true, message: "请选择车辆购入时间", trigger: "blur" },
        ],
        asset: [
          { required: true, message: "请填写资产金额", trigger: "blur" },
        ],
        amortization: [
          { required: true, message: "请填写摊销年限", trigger: "blur" },
        ],
        vtype: [
          { required: true, message: "请选择车种", trigger: "blur" },
        ],
        prepaid_type_id: [
          { required: true, message: "请选择预支款类型", trigger: "blur" },
        ],
      },
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .info_form {
  padding-top: 20px;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form {

    /*padding-top: 20px;
		border-radius: 5px;
		box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);
		background-color: #fff;*/
    .el-form-item {
      /*border-bottom: 1px solid #f2f6fc;*/
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      .el-input {
        width: 300px;
      }

      /*.el-form-item__content > div {
        width: 300px;
      }*/
      .el-upload__tip {
        left: 107px;
        top: 2px;
        width: 180px;
      }

      .el-button--small {
        padding: 12px 21px;
        font-size: 14px;
      }
    }

    .subform::before {
      width: 110%;
      height: 10px;
      background: #f9f9f9;
      content: "";
      //margin-bottom: 20px;
    }
  }
}


.instyle {
  display: inline-block;
}

.bainfo {
  padding-bottom: 20px;
}

.info_form .el-form .subform {
  margin-bottom: 0;
}

/*.info_form .el-form .el-form-item:nth-child(9) {
  display: block;
}*/
/deep/ .el-form .el-form-item.remind .content {
  display: block;

  .left:nth-child(2) {
    margin-left: 180px;
    margin-top: 20px;
  }
}

/deep/ .self {
  >.el-form-item__label {
    float: none !important;
    display: block;
    margin: 39px 0 18px 112px;
    text-align: left;
    font-size: 18px;
    color: #333;
  }

  >.el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-form .el-row:nth-child(4) .el-col-8 .subform::before {
  display: none;
}

.el-form .el-row:nth-child(4) .el-col-16 .subform::before {
  display: none;
}

.el-col-16 .self {
  margin-left: -54px;
}

.el-row .el-col .self:first-child {
  margin-bottom: 40px;
}

/deep/.info_form .el-form .el-row:nth-child(2) {
  padding-bottom: 20px;
}

/deep/ .subform .el-row .el-col-8 .el-form-item:last-child {
  margin-bottom: 40px;
}

.tit_label {
  margin: 26px 0 26px 112px;
  font-size: 18px;
  color: #333;
}

/deep/.el-icon-arrow-right:before {
  content: "";
}

/deep/ .breadcrumb .el-icon-arrow-right:before {
  content: "\e6e0";
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
